import type { App } from 'vue'

// 需要全局引入一些组件，如ElScrollbar，不然一些下拉项样式有问题
import { ElLoading, ElScrollbar } from 'element-plus'

const plugins = [ElLoading]

const components = [ElScrollbar]

const patchLoadingService = () => {
  const service = ElLoading.service
  if ((service as any).__contentTargetPatched) return

  const patchedService = ((options: any = {}) => {
    if (!options?.target && !options?.fullscreen && typeof document !== 'undefined') {
      const target =
        document.querySelector('.outsetTyMainBox') ||
        document.querySelector('.v-layout-content-scrollbar') ||
        document.querySelector('.v-layout-app-view')
      if (target) {
        return service({
          ...options,
          target
        })
      }
    }

    return service(options)
  }) as typeof ElLoading.service

  ;(patchedService as any).__contentTargetPatched = true
  ;(ElLoading as any).service = patchedService
}

export const setupElementPlus = (app: App<Element>) => {
  patchLoadingService()

  plugins.forEach((plugin) => {
    app.use(plugin)
  })

  // 开发环境可选择一次性引入所有样式；默认保持按需导入以贴近旧项目行为。
  if (import.meta.env.VITE_USE_ALL_ELEMENT_PLUS_STYLE === 'true') {
    import('element-plus/dist/index.css')
    return
  }

  components.forEach((component) => {
    app.component(component.name!, component)
  })
}
